<template>
  <div class="containers mx-auto allBoxImg mt-10">
    <div class="flex">
      <div class="w-full pt-16 px-32">
        <div class="md:px-0 lg:px-0 text-center">
          <div class="text-gray-500">
            <p class="pt-2">{{ errorMsg }}</p>
          </div>
          <div class="pt-8">
            <a :href="helpmateLink" target="_blank"><img src="@/assets/images/support.png" class="mx-auto" /></a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!renderReady" class="flex flex-col h-min-screen justify-center text-center">
      <img class="mb-8 block mx-auto loadercss mt-3%" src="@/assets/images/loadernew.gif" alt="Loader Gif" />
      <p class="mx-auto mb-10 leading-normal px-4 loadertextcss ext-genpact-darkest-blue">Loading...</p>
    </div>
  </div>
</template>
<script>
import { defineComponent, onBeforeMount, ref } from 'vue';

export default defineComponent({
  name: 'NotFound',

  setup() {
    const errorMsg = ref();
    const renderReady = ref();
    const helpmateLink = ref(localStorage.getItem('helpmateLink'));
    onBeforeMount(async () => {
      renderReady.value = false;
      errorMsg.value = localStorage.getItem('errorMsg');
      renderReady.value = true;
    });
    return { errorMsg, helpmateLink, renderReady };
  },
});
</script>
